// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TooltipV2-tooltip-2sRxc {\n  padding: 10px;\n  background-color: #4d4d4c;\n  border-radius: 5px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05), 1px 1px 4px rgba(0, 0, 0, 0.04);\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  max-width: 200px;\n  z-index: 700;\n  --fi-size: 14px;\n  --fi-stroke: var(--fi-stroke-s);\n}\n.TooltipV2-tooltip-2sRxc .rich-text-view p {\n  font-size: 13px;\n  --fi-size: 14px;\n}\n.TooltipV2-tooltipOneline-vMUPW {\n  max-width: unset;\n  white-space: nowrap;\n}\n", ""]);
// Exports
exports.locals = {
	"tooltip": "TooltipV2-tooltip-2sRxc",
	"tooltipOneline": "TooltipV2-tooltipOneline-vMUPW"
};
module.exports = exports;
